<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <n-divide class="table-tools">
      <div></div>
      <n-link v-if="edit.records" :to="createRecordLink()"><n-button>Создать запись</n-button></n-link>
    </n-divide>

    <n-table :columns="columns" :data="data">
      <template #headerRow>
        <tr class="header">
          <td rowspan="2">№ п.п.</td>
          <td rowspan="2">Дата и время записи</td>
          <td rowspan="2">Время между записями</td>
          <td rowspan="2">Сведения о ходе бетонирования и бетоне</td>
          <td rowspan="2">№ бетонолитных труб</td>
          <td rowspan="2">Диаметр бетонолитной трубы, см</td>
          <td rowspan="2">Количество бетона, м3, уложенного в блок, анкеровка контрольных образцов бетона</td>
          <td rowspan="2">Средняя скорость бетонирования, м/ч</td>
          <td rowspan="2">Отметка верха оболочки колодца ограждения, котлована и т.д.</td>
          <td rowspan="2">Отметка грунта в полости оболочки, диаметр скважины, котлована, м</td>
          <td rowspan="2">Отсчёт по трубе, м</td>
          <td colspan="5">Глубина в контрольных точках шахт, котлованов (в оболочках, уширениях только у трубы), м</td>
          <td rowspan="2">Заглубление трубы в бетонную смесь, м</td>
          <td rowspan="2">Средний слой поверхности бетона</td>
          <td rowspan="2">Уровень бетонной смеси в трубе от низа, м</td>
          <td rowspan="2">Подписи сменного мастера, лаборанта и бригадира</td>
          <td rowspan="2"></td>
        </tr>
        <tr class="header">
          <td>у трубы</td>
          <td>№ 1</td>
          <td>№ 2</td>
          <td>№ 3</td>
          <td>№ 4</td>
        </tr>
        <tr class="header">
          <td>1</td>
          <td>2</td>
          <td>3</td>
          <td>4</td>
          <td>5</td>
          <td>6</td>
          <td>7</td>
          <td>8</td>
          <td>9</td>
          <td>10</td>
          <td>11</td>
          <td>12</td>
          <td>13</td>
          <td>14</td>
          <td>15</td>
          <td>16</td>
          <td>17</td>
          <td>18</td>
          <td>19</td>
          <td>20</td>
          <td></td>
        </tr>
      </template>
      <template #date="{item}">
        {{ $app.date.format(item.date) }} {{ item.shift }}
      </template>
      <template #signs="{item}">
        <c-journal-sign :sign="getSign(item, 'records')" />
        <c-journal-sign :sign="getSign(item, 'lab')" />
        <c-journal-sign :sign="getSign(item, 'master')" />
      </template>
      <template #tools="{item}">
        <n-link :to="showRecordLink(item.id)"><n-button icon="eye" /></n-link>
      </template>
    </n-table>

    <page-record-create v-if="newRecord" :project="project" :journal="journal" @reload="load" @close="$router.push(createRecordLink(false))" />
    <modal-record v-if="showRecord" :project="project" :journal="journal" @reload="load" @close="$router.push(showRecordLink(false))" />
  </div>
</template>

<script>
import PageRecordCreate from './Create'
import ModalRecord from './record/Index'
import utils from 'utils'
import CJournalSign from 'components/journal/Sign'

export default {
  name: 'MainChapter4',
  components: { ModalRecord, PageRecordCreate, CJournalSign, },
  props: [ 'project', 'journal', ],
  data: () => ({
    utils,
    data: [
    ],
  }),
  computed: {
    newRecord() {
      return this.$route.query['new'] !== undefined
    },
    showRecord() {
      return this.$route.query['show'] !== undefined
    },
    edit() {
      return {
        records: $app.auth.can('journals_spec35_records', this.project.id),
      }
    },
    columns() {
      return [
        { name: 'number', title: '', },
        { name: 'date', title: '', },
        { name: 'time', title: '', },
        { name: 'information', title: '', },
        { name: 'pipeNumber', title: '', },
        { name: 'diameter', title: '', },
        { name: 'concreteCount', title: '', },
        { name: 'speed', title: '', },
        { name: 'topMark', title: '', },
        { name: 'earthMark', title: '', },
        { name: 'pipeReport', title: '', },
        { name: 'deep1', title: '', },
        { name: 'deep2', title: '', },
        { name: 'deep3', title: '', },
        { name: 'deep4', title: '', },
        { name: 'deep5', title: '', },
        { name: 'deepening', title: '', },
        { name: 'layer', title: '', },
        { name: 'level', title: '', },
        { name: 'signs', title: '', },
        { name: 'tools', title: '', },
      ]
    },
  },
  watch: {
    project() {
      this.load()
    },
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.journals.records.get(this.project.id, 'spec35')
        .query({
          'with[author][with][participation]': null,
          'with[signs][with][author]': null,
          projectId: this.project.id,
        })
        .then((response) => {
          this.data = response.data.content
        }).finally(() => {
          this.$var('load', false)
        })
    },
    getUser(item, name) {
      if (!item[name]) {
        return ''
      }
      return item[name]?.participation?.position + ', ' + item[name]?.fullName
    },
    createRecordLink(open = true) {
      return { query: { ...this.$route.query, 'new': open ? null : undefined, }, }
    },
    showRecordLink(open) {
      return { query: { ...this.$route.query, 'show': open || undefined, }, }
    },
    getSign(item, name) {
      return $n.find(item.signs, [ 'name', name, ])
    },
  },
}
</script>

<style lang="scss" scoped>
.main-chapter1 {

}
</style>
